// utils/analytics.js

export const logEvent = async (event, metadata = {}) => {
  try {
    const visitorId = getVisitorId();
    await fetch("/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        metadata: {
          ...metadata,
          page: window.location.pathname,
          userAgent: navigator.userAgent,
          visitorId
        },
        timestamp: new Date().toISOString()
      })
    });
  } catch (err) {
    console.warn("Tracking failed:", err.message);
  }
};

const getVisitorId = () => {
  let id = localStorage.getItem("visitorId");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("visitorId", id);
  }
  return id;
};
